module.exports = __webpack_public_path__ + "img/roll8.93472e76.png";